"use client";

import { useRef, type ReactNode } from "react";

import { useInViewOnce } from "./useInViewOnce";

type MountWhenNearProps = {
  children: ReactNode;
  /** Reserves the space so mounting never shifts the layout. */
  className: string;
};

/**
 * Renders its children only when they come within 600px of the viewport.
 * Keeps heavy animated visuals out of the initial hydration.
 */
export const MountWhenNear = ({ children, className }: MountWhenNearProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const near = useInViewOnce(ref, "600px 0px 600px 0px");
  return (
    <div ref={ref} className={className}>
      {near ? children : null}
    </div>
  );
};
